export function formatNumber(value: number) {
  return new Intl.NumberFormat("en-IN").format(value);
}

export function formatDateTime(value: string | null | undefined) {
  if (!value) {
    return "-";
  }
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) {
    return "-";
  }
  return new Intl.DateTimeFormat("en-IN", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit"
  }).format(date);
}

export function labelFromCode(value: string) {
  return value
    .toLowerCase()
    .split("_")
    .map((part) => part.slice(0, 1).toUpperCase() + part.slice(1))
    .join(" ");
}

export function statusTone(status: string) {
  if (status === "FAILED" || status === "HIGH" || status === "DISABLED" || status === "DISCONNECTED" || status === "BLOCKED") {
    return "danger";
  }
  if (status === "PARSING" || status === "UPLOADED" || status === "NEEDS_REVIEW" || status === "PENDING" || status === "SUSPENDED" || status === "AWAITING_ARTWORKS" || status === "MEDIUM") {
    return "warning";
  }
  if (status === "ACTIVE" || status === "COMPLETED" || status === "ACCEPTED" || status === "READY" || status === "IN_PROGRESS" || status === "LOW") {
    return "success";
  }
  return "neutral";
}
